<template>
    <b-container 
        class="content" 
        fluid 
    >
        <b-row align-h="between" style="background-color: white">
            <b-col class="float-left mt-1" cols="3" sm="3" style="font-weight: bold; text-align: center; font-size: 1.2em;">
                <div style="position: relative; width: 70px;">
                    <span class="float-left" style="font-size: 1.4em">{{ $t('sitesTitle') }}</span>
                    <span style="font-size: 0.8em; color: #868e96; position: absolute; margin: 10px 2px">({{filteredItems.length}})</span>
                </div>
            </b-col>
            <b-col >
                <b-row align-h="end">
                    <b-col >
                            <b-form-checkbox
                                v-model="selectedNoAgent"
                                value="1"
                                unchecked-value="0">
                                <b>{{ $t('sitesWithoutAgents') }}</b>
                            </b-form-checkbox>
                    </b-col>
                    <b-col >
                        <b-form-select v-model="selectedRegionId" :options="regions" class="gray-select" text-field="display_name" value-field="id"/>
                    </b-col>
                    <b-col class="placeholder-color-white">
                        <b-form-input v-model="searchInput" :placeholder="$t('siteSearchPlaceholder')" type="text" class="gray-input"/>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <div class="container-card table-responsive">
            <table class="table table-hover mt-2" style="table-layout: fixed; font-size: 0.875em; margin-bottom: 0">
                <tbody>
                    <tr v-for="filteredItem in filteredItems">
                        <td @click="routeTo(filteredItem)" style="cursor: pointer;">{{filteredItem.name}}</td>
                    </tr>
                    <!--
                    <tr @click="$router.push({name: 'admin-site-create'})" class="insert-row">
                        <td>
                            <i class="fas fa-plus-circle fa-2x"></i>
                        </td>
                    </tr>
                    -->
                </tbody>
            </table>
        </div>
    </b-container>
</template>

<script>
export default {
    name: 'Site',
    data() {
        return {
            searchInput: '',
            regions: [],
            selectedRegionId: null,
            selectedNoAgent: null,
            filteredAllSites: [],
            filteredNoAgents: []
        };
    },
    methods: {
        routeTo(site) {
            this.$router.push({name: 'admin-site-edit', params: {site_id: site.id}});
        }
    },
    computed: {
        // Start searching from the start if less than 4 characters are entered
        // Otherwise search from any position
        // If selected
        filteredItems() {
            if (this.selectedNoAgent == 1) {
                this.filteredNoAgents = this.sites.filter(item => {
                    return this.isAgentFound(item.agentIds, this.selectedNoAgent);
                });
                if (this.searchInput.length <= 3) {
                    this.filteredAllSites = this.filteredNoAgents.filter(item => {
                        return (
                            this.textStartsWith(item.code + item.name, this.searchInput) &&
                            this.isRegionFound(this.selectedRegionId, item.siteGroupId)
                        );
                    });

                    if (this.filteredAllSites.length) {
                        return this.filteredAllSites;
                    }
                }
                return this.filteredNoAgents.filter(item => {
                    return (
                        this.isSearchTextFound(item.code + item.name, this.searchInput) &&
                        this.isRegionFound(this.selectedRegionId, item.siteGroupId)
                    );
                });
            } else {
                if (this.searchInput.length <= 3) {
                    this.filteredAllSites = this.sites.filter(item => {
                        return (
                            this.textStartsWith(item.code + item.name, this.searchInput) &&
                            this.isRegionFound(this.selectedRegionId, item.siteGroupId)
                        );
                    });

                    if (this.filteredAllSites.length) {
                        return this.filteredAllSites;
                    }
                }
                return this.sites.filter(item => {
                    return (
                        this.isSearchTextFound(item.code + item.name, this.searchInput) &&
                        this.isRegionFound(this.selectedRegionId, item.siteGroupId)
                    );
                });
            }
            //isAgentFound() filters by checking member of site related to sustainability.
        }
    },
    created() {
        this.regions = [{id: null, display_name: this.$t('allRegions')}, ...this.siteGroups];
    }
};
</script>

<style scoped>
</style>

<i18n src="../../i18n/common.json"></i18n>

<i18n>
    {
        "tr": {
            "sitesTitle": "Lokasyonlar",
            "tableSiteName": "Lokasyon Adı",
            "tableDataHealth": "Veri Sağlığı",
            "sitesWithoutAgents": "Sürdürülebilirlik Temsilcisi Olmayanlar"
        },
        "en": {
            "sitesTitle": "Sites",
            "tableSiteName": "Site",
            "tableDataHealth": "Data Health",
            "sitesWithoutAgents": "Sites without agents"
        }
    }
</i18n>



// WEBPACK FOOTER //
// src/views/Setting/Site.vue